import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { trackDiscoveryCallClick, trackRegistrationClick } from '@/utils/analytics';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';
import { handleDiscoveryCallClick } from '@/components/layout/Navbar';

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const { links } = useSiteSettings();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  let text = 'Book a Discovery Call';
  let href = links.bookingUrl;
  let onClick = () => {
    handleDiscoveryCallClick(links.bookingUrl);
    trackDiscoveryCallClick('sticky_bar');
  };

  if (location.pathname.includes('certification') || location.pathname.includes('pricing')) {
    text = 'Register for Next Cohort';
    href = '/register';
    onClick = () => trackRegistrationClick('sticky_bar');
  } else if (location.pathname === '/') {
    text = 'Take the Free Team Diagnostic';
    href = '/diagnostic';
    onClick = () => trackDiscoveryCallClick('sticky_bar');
  }

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 lg:hidden bg-gradient-to-r from-rule-3/60 to-rule-3/70 text-white py-3 px-6 z-[90] transform transition-transform shadow-md flex items-center justify-between">
      <div className="w-full">
        <a 
          href={href} 
          onClick={onClick}
          target={href.startsWith('http') ? '_blank' : undefined}
          rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
          className="block w-full text-center bg-ink text-white px-8 py-3 uppercase tracking-widest text-xs font-bold hover:bg-ink/70 transition-colors shadow-sm"
        >
          {text}
        </a>
      </div>
    </div>
  );
};
